import { FC } from 'react';

import { UnsubscribeEmailBasePage } from 'pages/UnsubscribeEmailBasePage';

export const UnsubscribeReportBuilderEmailPage: FC = () => (
  <UnsubscribeEmailBasePage unsubscribePath="unsubscribe/report_builder_email/" />
);
